(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContentTypeGroupSearchResults',
		[
			ContentTypeGroupSearchResultsDirective
		])
		.controller('ContentTypeGroupSearchResultsController',
		[
			'smbToolbarService',
			'gettextCatalog',
			'smbContentTypeGroupConfigDataStore',
			'smbContentTypeConfigDataStore',
			'smbIconTypes',
			'smbContentSearchDataStore',
			'smbDocumentViewerNavigationService',
			ContentTypeGroupSearchResultsController
		]);

	var templateUrl = require('./contentTypeGroupSearchResults.template');
	function ContentTypeGroupSearchResultsDirective() {
		return {
			restrict: 'E',
			controller: ContentTypeGroupSearchResultsController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				groupId: '@'
			}
		};
	}

	function ContentTypeGroupSearchResultsController(smbToolbarService, gettextCatalog, smbContentTypeGroupConfigDataStore,
								smbContentTypeConfigDataStore, smbIconTypes, smbContentSearchDataStore, smbDocumentViewerNavigationService) {

		smbToolbarService.set(gettextCatalog.getString('Document Group Search Results'), 'search.contentTypeGroups.contentTypes.groupSearch');

		var vm = this;
		vm.contentSearchDS = smbContentSearchDataStore;
		vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
		vm.contentTypeDS = smbContentTypeConfigDataStore;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];
		vm.documentNavigation = smbDocumentViewerNavigationService;

		(function loadSearchResults() {
			smbContentSearchDataStore.getContentTypeGroupSearchResults(vm.groupId);
		})();
	}
}());



//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeGroupSearchResults/contentTypeGroupSearchResults.js
// module id = 71
// module chunks = 1